import { render, staticRenderFns } from "./StepBusiness.vue?vue&type=template&id=8842c64e"
import script from "./StepBusiness.vue?vue&type=script&lang=js"
export * from "./StepBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports